export const environment = {
  production: false,
  backend: 'https://bsh-api-sx.bizerba.com/api/',
  backendScope: 'https://bsh-api-sx.bizerba.com/Access'
};
